import React, { Component } from 'react';
import { Button, Popconfirm, Space, Table, Spin, PageHeader, Layout, message } from 'antd'
import axios from 'axios';

//Componentes
import { IconDelete, IconEdit,IconArrowBack } from '../../Widgets/Iconos';
import FloatingButton from "../../Widgets/Floating Button/FloatingButton";
import ModalInventarioProducto from "./ModalInventarioProducto";
import ModalInventarioProductoMultiple from './ModalInventarioProductoMultiple'

const { Content } = Layout;

/**
 * @export
 * @class Productos
 * @extends {Component}
 * @description Vista de Productos
 */
export default class AlmacenProductos extends Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            modalVisible: false,
            ids: [],

            productos: {
                data: [],
                page: 1,
                limit: 10,

                total: 0,
                pages: 0
            }
        }
    }

    componentDidMount() {
        this.props.updateFilterSearch(true);

        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');
        this.getProductos();
    }


    /**
     *
     *
     * @memberof Transacciones
     * 
     * @method componentDidUpdate
     * @description Actualiza la vista si se buscan datos
     */
    componentDidUpdate(prevProps) {
        const filtro = this.state.filtroSearch;
        const propFiltro = this.props.search;

        console.log('Search prop changed:', this.props.search);
        console.log('Previous search prop:', prevProps.search);
        if (this.props.search !== prevProps.search && this.state.searching == true) {
            this.getProductos();
        }
    }


    getProductos = ({
        page = 1,
        limit = this.state.clientes.limit,

        search = this.props.search,

    } = this.state.productos) => {

        const { almacen_id, inventario_id } = this.props.match.params
        this.setState(state => {
            state.productos.page = page;
            state.productos.limit = limit;
            return state
        })
        axios.get('/inventarios/productos', {
            params: {
                page,
                limit,
                search,
                almacen_id,
                inventario_id
            }
        })
            .then(({ data }) => {
                this.setState(state => {
                    state.productos.data = data.data.data
                    state.productos.total = data.data.total
                    state.productos.pages = data.data.pages
                    state.ids = data.data.data.map(item => item.producto_id._id)
                    return state;
                })
            })
            .catch(error => {
                // console.log(error)
                message.error('Error al traer la información')
            })
    }


    showModal = (producto_id = undefined) => this.setState({ modalAlmacenProducto: true, producto_id })

    back = () => {
        this.props.history.goBack();
     }
    render() {

        const { showModal } = this
        const { productos } = this.state

        const contentMenuPlus = (
            <div className="flex-column">
                <Button type="primary" className="width-100 mb-05" onClick={() => showModal()}>
                    Añadir Producto
                </Button>
                <Button type="primary" className="width-100" onClick={() => this.setState({ modalVisibleCSV: true })}>
                    Añadir Múltiples
                </Button>
            </div>
        );

        return (
            <Spin spinning={false}>
                <PageHeader
                    className="site-page-header custom-page-header"
                    title="Productos"
                    backIcon={<IconArrowBack/>}
                    onBack={this.back}
                />
                <Content className="admin-content content-bg pd-1 mb-3">
                    <Table
                        rowKey={record => record._id}
                        locale={{ emptyText: "Sin Productos en el Inventario" }}
                        dataSource={productos.data}
                        pagination={{
                            onChange: (page, limit) => this.getProductos({ page, limit }),
                            current: productos.page,
                            pageSize: productos.limit,
                            total: productos.total,

                            hideOnSinglePage: false,
                            position: ['bottomLeft'],
                        }}
                        columns={[
                            {
                                title: 'Número de Parte del Fabricante',
                                dataIndex: 'producto_id',
                                key: 'np_fabricante',
                                render: (text, record) => (
                                    <span>{record.producto_id?.np_fabricante}</span>
                                ),
                            },
                            {
                                title: 'Número de Parte del Cliente',
                                dataIndex: 'np_cliente',
                                key: 'np_cliente',
                            },
                            {
                                title: 'Cantidad',
                                dataIndex: 'cantidad',
                                key: 'cantidad',
                                align: 'right',
                                render: (text, record) => (
                                    <span>{record.cantidad?.toMoney(true) ?? 0}</span>
                                ),
                            },
                            {
                                title: 'Inventario Mínimo / Máximo',
                                key: 'inv_minimo_maximo',
                                align: 'right',
                                render: (text, record) => (
                                    <span>{record.inv_minimo?.toMoney(true) ?? 0} / {record.inv_maximo?.toMoney(true) ?? 0}</span>
                                ),
                            },
                            {
                                title: 'Precio del Producto',
                                dataIndex: 'precio',
                                key: 'precio',
                                align: 'right',
                                render: (text, record) => (
                                    <span>$ {record.precio?.toMoney(true) ?? '0.00'} MXN</span>
                                ),
                            },
                            {
                                title: 'Acciones',
                                key: 'actions',
                                fixed: 'right',
                                width: '110px',
                                render: (text, record) => (
                                    <Space>
                                        <Button type="primary" icon={<IconEdit />} onClick={() => showModal(record._id)} />
                                        <Popconfirm
                                            placement="topRight"
                                            title="¿Deseas eliminar este producto del inventario?"
                                            onConfirm={() => axios.post('/inventarios/productos/deleteProducto', { id: record._id })
                                                .then((response) => {
                                                    message.success("Eliminado Correctamente")
                                                    this.getProductos()
                                                })
                                                .catch((error) => {
                                                    message.error(error?.response?.data?.message || "No es posible eliminar")
                                                    this.getProductos();
                                                })
                                            }
                                            okText="Si"
                                            cancelText="No"
                                        >
                                            <Button type="normal" danger icon={<IconDelete />} title="Eliminar" />
                                        </Popconfirm>
                                    </Space>
                                ),
                            },
                        ]}
                    />

                    <FloatingButton content={contentMenuPlus}  />
                </Content>
                <ModalInventarioProducto
                    id={this.state.producto_id}
                    producto_ids = {this.state.ids}
                    inventario_id={this.props.match.params.inventario_id}
                    visible={this.state.modalAlmacenProducto}
                    onCancel={() => {
                        this.setState({ modalAlmacenProducto: false })
                        this.getProductos()
                    }}
                />
                <ModalInventarioProductoMultiple 
                    visible={this.state.modalVisibleCSV}
                    onClose={(flag)=>{
                        this.setState({modalVisibleCSV: false})
                        this.getProductos()
                    }}
                    inventario_id={this.props.match.params.inventario_id}
                />
            </Spin>
        )
    }
}